import { render, staticRenderFns } from "./showpushform.vue?vue&type=template&id=2ca97fab&scoped=true&"
import script from "./showpushform.vue?vue&type=script&lang=js&"
export * from "./showpushform.vue?vue&type=script&lang=js&"
import style0 from "./showpushform.vue?vue&type=style&index=0&id=2ca97fab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca97fab",
  null
  
)

export default component.exports